type NumberFormat = 'decimal' | 'currency' | 'percent' | 'unit';

const cleanCurrency = (value: number | string | null | undefined): string => {
  const valueStr = typeof value === 'number' ? value.toString() : value;
  return typeof valueStr === 'string' ? valueStr.replace(/[^0-9,-.]+/g, '') : '';
};

const initFormatter = ({
  style = 'currency',
  ...props
}: {
  style?: NumberFormat;
  props?: Intl.NumberFormatOptions;
} = {}) =>
  new Intl.NumberFormat('es-cl', {
    currency: 'CLP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...props,
    style,
  });

export const formatCurrency = (
  value: number | string | null | undefined,
  {
    isDebt = false,
    clearZero = true,
    currencyStyle = 'currency',
  }: {
    isDebt?: boolean;
    clearZero?: boolean;
    currencyStyle?: NumberFormat;
  } = {},
): string => {
  const cleanValue = cleanCurrency(value);
  if (cleanValue === '0' && clearZero) return '-';
  if (cleanValue.length < 1) return cleanValue;
  const formatter = initFormatter({ style: currencyStyle });
  const cleanNumber = parseFloat(cleanValue) * (isDebt ? -1 : 1);
  return formatter.format(cleanNumber);
};

export const formatNumberAsCurrency = (number: number): string =>
  formatCurrency(number, { currencyStyle: 'decimal' });
